// Admin -> Sheets import (4 qadam), ru
export default {
  title: "Импорт из Sheets",
  subtitle: "Разовый перенос из текущих Google Sheets · вместе с командой разработки",
  ownerOnly: "Только для владельца",
  ownerOnlyDesc: "Импортировать данные может только владелец.",
  steps: { connect: "Подключить таблицу", map: "Сопоставить столбцы", preview: "Проверка и дубликаты", import: "Импорт" },
  connect: {
    fileRead: "Файл прочитан",
    fileReadDesc: "строк: {{rows}} · столбцов: {{cols}}",
    fileFailed: "Не удалось прочитать файл.",
    pasteLink: "Вставьте ссылку на Google Sheets.",
    sheetConnected: "Таблица подключена",
    sheetConnectedDesc: "строк: {{rows}}",
    sheetFailed: "Не удалось подключиться к таблице.",
    uploadTitle: "Загрузить файл",
    uploadDesc: "CSV или XLSX, выгруженный из Google Sheets",
    dropHere: "Перетащите файл сюда или",
    browse: "выберите",
    limit: "CSV или XLSX, до 20 МБ",
    howTo: "В Google Sheets: Файл → Скачать → CSV (один лист на файл).",
    template: "Скачать шаблон",
    readFile: "Прочитать файл",
    linkTitle: "Ссылка на Google Sheets",
    linkDesc: "Подключить живую таблицу через Sheets API",
    sheetUrl: "URL таблицы",
    tabName: "Название листа",
    tabHint: "Оставьте пустым для первого листа",
    shareWith: "Откройте доступ к таблице для:",
    notConfigured: "Подключение к Google Sheets ещё не настроено — загрузите выгрузку CSV/XLSX.",
    connectSheet: "Подключить таблицу",
    googleConnected: "Чтение от имени {{email}}",
    googleConnectedHint: "Таблица должна принадлежать этому аккаунту Google или быть ему открыта.",
    googleReauth: "Доступ к Google истёк.",
    googleReconnectLink: "Переподключить в Настройки → Интеграции",
    googleNotConnected: "Аккаунт Google не подключён.",
    googleConnectLink: "Подключить в Настройки → Интеграции",
    googleOrShare: "Или откройте доступ к таблице сервисному аккаунту:",
    previous: "Предыдущие импорты",
    noImports: "Импортов пока нет.",
    col: { file: "Файл / таблица", when: "Когда", who: "Кто", status: "Статус", rows: "Строк", imported: "Импортировано", errors: "Ошибок" },
    importN: "Импорт #{{id}}",
  },
  status: { uploaded: "Загружен", mapped: "Сопоставлен", previewed: "Проверен", importing: "Импортируется", done: "Готово", failed: "Ошибка" },
  map: {
    phoneRequired: "Сопоставьте столбец «Телефон»: он обязателен.",
    usedTwice: "Одно поле использовано дважды: {{fields}}.",
    saveFailed: "Не удалось сохранить сопоставление.",
    connected: "Подключено:",
    rowsCols: "строк: {{rows}} · столбцов: {{cols}}",
    tabs: "листы: {{tabs}}",
    columnMapping: "Сопоставление столбцов",
    step2: "шаг 2",
    col: { sheet: "Столбец таблицы", sample: "Пример значения", field: "Поле в системе", req: "Обяз." },
    fieldFor: "Поле для {{col}}",
    yes: "да",
    twice: "дважды",
    skipped: "пропущен",
    ok: "✓ ок",
    phoneHint: "Телефон обязателен: выберите столбец с номерами телефонов.",
    statusValues: "Значения статуса",
    statusSubtitle: "значений в таблице: {{n}} · не сопоставлено: {{unmapped}}",
    noStatusColumn: "Столбец статуса не сопоставлен — все начинают как «Новый»",
    inSheet: "В таблице",
    inSystem: "В системе",
    statusFor: "Статус для {{raw}}",
    mapStatusHint: "Сопоставьте столбец со «Статусом» выше, чтобы перевести формулировки таблицы в статусы воронки.",
    owner: "Владелец",
    ownerDesc: "Кому достаются импортированные водители",
    useColumn: "Использовать столбец «Рекрутер»",
    useColumnHint: "Имена или email сопоставляются с пользователями; не найденные → владелец по умолчанию ниже.",
    useColumnMissing: "Сначала сопоставьте столбец с «Рекрутер (владелец)».",
    single: "Назначить всех одному рекрутеру",
    pool: "Без владельца (пул филиала / команды)",
    poolHint: "Руководитель команды распределит позже.",
    recruiter: "Рекрутер",
    defaultOwner: "Владелец по умолчанию (для не найденных имён)",
    nonePool: "— нет (пул) —",
    branch: "Филиал",
    choose: "— выберите —",
    team: "Команда",
    branchPool: "— пул филиала —",
    defaultSource: "Источник по умолчанию",
    defaultSourceHint: "Используется, если столбец «Источник» пуст или не сопоставлен",
    nothingWritten: "Ничего не записывается, пока вы не нажмёте «Импорт».",
    back: "Назад",
    savePreview: "Сохранить и проверить",
  },
  preview: {
    imported: "Импортировано водителей: {{n}}",
    failed: "Импорт не выполнен.",
    failedTitle: "Импорт не выполнен",
    step2done: "шаг 2, готово",
    ownerFrom: "Владелец:",
    ownerColumn: "из столбца «Рекрутер»",
    ownerSingle: "один рекрутер",
    ownerPool: "пул филиала / команды",
    unresolved: "строк без найденного владельца: {{n}} (идут в пул)",
    statusUnmapped: "не сопоставлено значений статуса: {{n}} → Новый",
    title: "Проверка",
    step3: "шаг 3",
    rowsFound: "Найдено строк",
    ready: "Готово к импорту",
    duplicates: "Объединено дубликатов",
    errors: "Ошибки (не импортируются)",
    reformatted: "Переформатировано телефонов",
    whyFail: "Почему не проходят {{n}} строк",
    dupHint: "Дубликаты: водитель, который уже есть (тот же телефон или CDL), пропускается — у существующей записи остаётся её владелец. Пример: водитель из таблиц двух рекрутеров становится одной записью, закреплённой за тем, кто добавил его первым.",
    downloadErrors: "Скачать строки с ошибками",
    notImported: "Строки не импортированы ({{n}})",
    notImportedDesc: "Показаны первые 20 · исправьте их в таблице и импортируйте снова",
    col: { row: "Строка", reason: "Причина", values: "Значения" },
    transaction: "Ничего не записывается, пока вы не нажмёте «Импорт». Импорт идёт одной транзакцией: все строки или ни одной.",
    importing: "Импортируется…",
    importN: "Импортировать водителей: {{n}}",
  },
  done: {
    importing: "Импортируется…",
    failed: "Импорт не выполнен — ничего не записано",
    unknown: "Неизвестная ошибка.",
    backToPreview: "Назад к проверке",
    another: "Начать новый импорт",
    imported: "Импортировано водителей: {{n}}",
    history: "в истории каждого водителя видно «Импортировано из …»",
    rowsFound: "Найдено строк",
    importedLabel: "Импортировано",
    duplicates: "Объединено дубликатов",
    errors: "Ошибки (не импортируются)",
    goDrivers: "К водителям",
  },
};
